// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2Ruvw","choiceBoxes":"toolbarselects_choiceBoxes__hSsrM","simpleField":"toolbarselects_simpleField__3IUjr"};